import { store } from 'store';
import API, { createEmptyAxiosInstance } from 'utils/api';
import fileToBase64 from 'utils/fileToBase64';
import { onError } from 'utils/handlers';

const EXTERNAL_API = createEmptyAxiosInstance(false);
EXTERNAL_API.defaults.baseURL = 'https://465-gft-cfdi.migob.digital/';

export const getInfoUserParaFirma = (_values) => {
  const { user } = store.getState().auth;
  const values = {};
  if (!_values) {
    values.usuario = user.id;
    values.unidad_de_recaudacion = user.unidad_de_recaudacion || '';
    values.unidad_responsable = user.unidad_responsable || '';
    values.unidad_operativa = user.unidad_operativa || '';
    values.puesto = user.es_externo ? user.funcion_del_usuario_externo?.descripcion
      : user.funcionario?.puesto_principal?.descripcion;
  } else {
    values.unidad_de_recaudacion = _values.unidad_de_recaudacion || '';
    values.unidad_responsable = _values.unidad_responsable || '';
    values.unidad_operativa = _values.unidad_operativa || '';
    values.puesto = _values.puesto;
  }
  values.puesto = values.puesto || '';
  return values;
};

/**
 * Generar cadena para firmar tramite
 * @param {object} tramite
 * @param {string} tramite.firma_electronica
 * @param {string} tramite.folio
 * @returns string
 */
const generarCadena = (tramite) => {
  const _cadena = JSON.parse(tramite.firma_electronica || '[]')[0]?.cadena_original;
  return _cadena || tramite.folio;
};

/**
 * POST firmar cadena
 * @param {object} _values
 * @param {string} _values.rfc
 * @param {File} _values.archivo_cer
 * @param {File} _values.archivo_key
 * @param {string} _values.clave_privada
 * @param {?string} _values.uuid
 * @param {object} tramite
 * @param {string} tramite.firma_electronica
 * @returns Promise<Object|null>
 */
export const postFirmarCadena = async (
  {
    paso,
    archivo_cer,
    archivo_key,
    clave_privada,
    ..._values
  },
  tramite,
) => {
  try {
    const values = { ..._values, cadena_original: generarCadena(tramite) };
    values.clave_privada = btoa(clave_privada);
    [, values.archivo_cer_b64] = (await fileToBase64(archivo_cer.file))?.split(',') || '';
    [, values.archivo_key_b64] = (await fileToBase64(archivo_key.file))?.split(',') || '';

    if (values.usuario) {
      const response = await API.post('/tramites/firmado-automatico/', values);
      return {
        ...response.data.response,
        ...getInfoUserParaFirma(response.data.info_usuario),
      };
    }

    const response = await EXTERNAL_API.post('/sign/efirma', values);
    return {
      ...response.data,
      ...getInfoUserParaFirma(),
      paso,
    };
  } catch (err) {
    onError(err);
  }
  return null;
};

export default { postFirmarCadena };
